import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from '../../environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: 'https://dexidp.shared.beyonnex.io/dex',
    redirectUrl: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    clientId: environment.dexOidcClientId,
    scope: `openid groups email profile offline_access audience:server:client_id:${environment.environment}`,
    responseType: 'code',
    silentRenew: true,
    useRefreshToken: true,
    ignoreNonceAfterRefresh: true,
    maxIdTokenIatOffsetAllowedInSeconds: 300,
    renewTimeBeforeTokenExpiresInSeconds: 300,
    refreshTokenRetryInSeconds: 30,
    triggerRefreshWhenIdTokenExpired: true,
    autoUserInfo: false, // this was necessary because we had problems with getting 401 errors on login requests
    // Safari appends an empty '#' fragment to the Dex redirect callback URL, causing the library's
    // redirectUrl comparison to fail (http://localhost:4200/# !== http://localhost:4200/). Setting
    // this to false skips that URL equality check and detects the callback purely by the presence
    // of 'code' in the query params. The state check on the callback and the PKCE code verifier at the
    // token exchange still run, so no security regression.
    checkRedirectUrlWhenCheckingIfIsCallback: false,
    logLevel: LogLevel.Warn,
  },
};
